// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MuN6","content":"styles_content__zokxg"};